import React, { useContext } from 'react';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing'

import { InputLabel } from 'components/form/prototypes';

const ReplacementOrderNumber = () => {

  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled =
    ['QA', 'GM'].includes(user.role) &&
    ![4, 5].includes(state.ncr.status.id);

  return (
    <>
    <InputLabel
      name='ncr.replacement_order_number'
      label='Subsidiary Order Ref.'
      disabled={isDisabled} />
    </>
  )
}

export { ReplacementOrderNumber };
